import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { useCart, formatPrice } from "../context/CartContext";

export const buildWaMessage = (t, items, products, currency) => {
  let msg = t("wa.greeting") + "\n";
  items.forEach((i) => {
    const p = products.find((pr) => pr.product_id === i.product_id);
    if (p) msg += `\n• Agrodyke ${p.weight_kg} kg × ${i.quantity} — ${formatPrice(p, currency, i.quantity)}`;
  });
  return msg;
};

export const WhatsAppFloat = () => {
  const { t } = useTranslation();
  const { config, items, products, currency } = useCart();
  const msg = items.length ? buildWaMessage(t, items, products, currency) : t("wa.greeting");
  const link = `https://wa.me/${config.whatsapp_number}?text=${encodeURIComponent(msg)}`;

  return (
    <a href={link} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float"
      className="fixed bottom-6 end-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl animate-pulse-ring hover:scale-110 transition-transform">
      <MessageCircle size={26} fill="white" />
    </a>
  );
};
